import React, { useRef, useEffect, useState } from 'react';
import 'index.css';
import './Pager.scss';

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const Pager = ({
    idx,
    pages,
}) => {
    const previousIdx = usePrevious(idx);
    const [height, setHeight] = useState(0);

    const ref = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!ref.current) return;
            setHeight(ref.current.clientHeight);
        }, 500);
        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <div className="pager" style={{ height }}>
            {previousIdx !== null && previousIdx !== idx && (
                <div
                    className="pager-page page-previous"
                    key={previousIdx}
                >
                    <div>
                        {pages[previousIdx]}
                    </div>
                </div>
            )}
            <div
                className="pager-page page-current"
                key={idx}
            >
                <div ref={ref}>
                    {pages[idx]}
                </div>
            </div>
        </div>
    );
};

export default Pager;
